const commonMaxWidth = 912;

export default commonMaxWidth;
